import axios from 'axios';
import config from '../config';
import { showError } from '../utils';
import { store } from '../store';

export function fetchMedicines(authToken, input, isSubstitute) {
  const headers = {
    authorization: authToken,
  };

  const transcriberAccountActive = store.getState().app.transcriberAccountActive;
  let pincode = transcriberAccountActive ? store.getState().digitisation.pincode : null;
  let partnerCode = transcriberAccountActive ? store.getState().digitisation.partnerAssignedId : null;
  const digitisationId = transcriberAccountActive ? store.getState().digitisation.digitisationRequestId : null;
  partnerCode = null;

  const urlWithPartnerId = `${config.pharmaServer}/medicines/search?s=${input}${pincode !== null ? `&pc=${pincode}` : ''}${partnerCode !== null ? `&partner=${partnerCode}&digitisationId=${digitisationId} ` : ''}`;

  const urlWithoutPartnerId = `${config.pharmaServer}/medicines/search?s=${input}${pincode !== null ? `&pc=${pincode}` : ''}&isSubstitute=${isSubstitute}`
  const finalUrl = isSubstitute?urlWithoutPartnerId:urlWithPartnerId;
  console.log({ finalUrl }, 'url for fetchMedicines');

  return axios
    .get(finalUrl, {
      headers,
      params: { v: config.dashboardVersion }
    })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody.result;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export async function fetchNewMedicines(query, searchSourceType, limit = 20, skipLocation = false, partnerId = null, isNiva, isBenefitLess, dimDrugId = null, isVisitClinic = false) {

  const { latitude, longitude, pincode, digitisationRequestId, userPhoneNumber } = store.getState().digitisation;
  const { authToken } = store.getState().user;
  let serviceablePartners = [];
  if(store.getState().prescription?.supportedPartners?.fetched){
    serviceablePartners = store.getState().prescription.supportedPartners.partners.map((partner) => partner.partnerId);
  }
  const headers = { authorization: authToken };

  try {
    const sourceIdQuery = searchSourceType == 'DIGITIZE-AND-BOOK' ? `&sourceId=${digitisationRequestId}` : '';
    const locationQuery = skipLocation && (isNiva ==0 && isBenefitLess==0) ? '' : `latitude=${latitude}&longitude=${longitude}&pincode=${pincode}&`;
    const partnerQuery = partnerId ? `&partnerIds[]=${partnerId}` : '';
    const isNivaBupaCase = isNiva ? `&isNivaBupaCase=1` : '';
    const isBenefitLessCase = isBenefitLess ? `&isBenefitLessCase=1` : '';
    const serviceablePartnersQuery = serviceablePartners.length ? `&serviceablePartners[]=${serviceablePartners}` : '';
    const dimDrugIdQuery = dimDrugId ? `&dimDrugId=${dimDrugId}` : '';
    const isVisitClinicQuery = isVisitClinic ? `&isVisitClinic=1` : '';
    const url = `${config.pharmaServer}/drug/search?${locationQuery}drugName=${query}&limit=${limit}${sourceIdQuery}&searchDrugSourceType=${searchSourceType}${partnerQuery}${isBenefitLessCase}${isNivaBupaCase}&phone=${userPhoneNumber}${serviceablePartnersQuery}${dimDrugIdQuery}${isVisitClinicQuery}`;
    const response = await axios.get(url, { headers });
    return response.data.drugs;
  } catch (err) {
    showError(err);
    throw err;
  }
}

export function fetchMedicinesFromDimDrugs(authToken, input, partnerId) {
  const headers = {
    authorization: authToken,
  };
  const transcriberAccountActive = store.getState().app.transcriberAccountActive;
  if (!authToken) {
    authToken = store.getState().user.authToken;
  }
  const pincode = transcriberAccountActive ? store.getState().digitisation.pincode : null;
  const digitisationId = transcriberAccountActive ? store.getState().digitisation.digitisationRequestId : null;
  const urlWithPartnerId = `${config.pharmaServer}/medicines/search/v1/by/partnerId?s=${input}&pincode=${pincode}&digitisationId=${digitisationId}${partnerId !== null ? `&partnerId=${partnerId} ` : ''}`;

  console.log({ urlWithPartnerId }, 'url for fetchMedicines');

  return axios
    .get(urlWithPartnerId, {
      headers,
      params: { v: config.dashboardVersion }
    })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody.result;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function fetchMedicinesFromElasticSearch(authToken, input) {
  const transcriberAccountActive = store.getState().app.transcriberAccountActive;
  const digitisationId = transcriberAccountActive ? store.getState().digitisation.digitisationRequestId : null;
  const headers = {
    authorization: authToken,
  };

  const ELASTIC_SEARCH_DRUG_URL = `${config.pharmaServer}/medicines/search/v1?s=${input}&digitisationId=${digitisationId}`;
  const finalUrl = ELASTIC_SEARCH_DRUG_URL;
  console.log({ finalUrl }, 'url for fetchMedicines');

  return axios
    .get(finalUrl, {
      headers,
      params: { v: config.dashboardVersion }
    })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody.result;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}
export function addMedicine(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  let url = `${config.apiBaseUrl}/prescriptions/medicines/add`;

  const state = store.getState();
  if (state.app.transcriberAccountActive) {
    url = `${config.apiBaseUrl}/digitisations/requests/medicines/add`;
  } else {
    body.transcriber = false;
  }

  return axios
    .post(url, body, { headers, params: { v: config.dashboardVersion } })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function deleteMedicine(
  authToken,
  medicineId,
  prescriptionId,
  digitisationId
) {
  const headers = {
    authorization: authToken,
  };

  const body = { medicineId };

  let url = `${config.apiBaseUrl}/prescriptions/${prescriptionId}/medicines/remove`;

  const state = store.getState();
  if (state.app.transcriberAccountActive) {
    body.digitisationId = digitisationId;
    url = `${config.apiBaseUrl}/digitisations/requests/medicines/remove`;
  } else {
    body.transcriber = false;
  }

  return axios
    .post(url, body, { headers })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

//diseases
export function getDiseases(authToken, searchQuery) {

  return axios
    .get(`${config.apiBaseUrl}/network/practice/search-disease`, {
      params: {
        q: searchQuery,
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody.result;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

//doctors
export function getDoctors(authToken, searchQuery) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/network/practice/doctors-doc`, {
      headers,
      params: {
        q: searchQuery,
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody.result;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

//Centers
export function getCenters(authToken, searchQuery) {
  const headers = {
    authorization: authToken,
  };
  const isDigitization = true

  return axios
    .get(`${config.apiBaseUrl}/network/practice/center-doc`, {
      headers,
      params: {
        q: searchQuery,
        isDigitization
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody.result;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getESCenters(authToken, searchQuery) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/network/practice/digitisations-maori-centers-search`, {
      headers,
      params: {
        keyword: searchQuery,
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody.results;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

// practices
export function getCenterDoctorPractices(authToken, searchQuery) {
  const headers = {
    authorization: authToken,
  };
  
  return axios
    .get
    (`${config.apiBaseUrl}/network/practice/digitisations-maori-center-doctor-search`, {
      headers,
      params: {
        keyword: searchQuery,
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody.results;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}
//get doctors for a center and non-empanelled doctors
export function getDoctorsForCenter(authToken, searchQuery, centerId) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/network/practice/search-doctors-in-center`, {
      headers,
      params: { keyword: searchQuery, centerId },
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

// lab tests
export function getLabTests(authToken, searchQuery) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/labs/all`, {
      headers,
      params: {
        s: searchQuery,
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody.labs;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function verifyMultipleTests(authToken, digitisationId) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/labs-v2/verify-servicability/${digitisationId}`, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return { data: responseBody.data, check: responseBody.check };
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function verifySingleTest(authToken, digitisationId, testId, partnerId) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/labs-v2/verify-test-coverage/${digitisationId}/${testId}/${partnerId}`, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody.covered;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function addLabTest(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  let url = `${config.apiBaseUrl}/prescriptions/labs/add`;

  const state = store.getState();
  if (state.app.transcriberAccountActive) {
    url = `${config.apiBaseUrl}/digitisations/requests/labs/add`;
  } else {
    body.transcriber = false;
  }

  return axios
    .post(url, body, { headers })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      // throw err;
    });
}

export function deleteLabTest(
  authToken,
  labId,
  prescriptionId,
  digitisationId
) {
  const headers = {
    authorization: authToken,
  };

  const body = { labId };

  let url = `${config.apiBaseUrl}/prescriptions/${prescriptionId}/labs/remove`;

  const state = store.getState();
  if (state.app.transcriberAccountActive) {
    url = `${config.apiBaseUrl}/digitisations/requests/labs/remove`;
    body.digitisationId = digitisationId;
  } else {
    body.transcriber = false;
  }

  return axios
    .post(url, body, { headers })
    .then((res) => {
      const responseBody = res.data;

      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function batchAddLabTests(authToken, tests) {
  const headers = {
    authorization: authToken,
  };

  let url = `${config.apiBaseUrl}/prescriptions/labs/batch/add`;

  const state = store.getState();
  if (state.app.transcriberAccountActive) {
    url = `${config.apiBaseUrl}/digitisations/requests/labs/batch/add`;
  }

  const body = {
    digitisationId: tests[0]?.digitisationId, // All tests should have the same digitisationId
    labTests: tests.map(test => ({
      labId: test.labId,
      labName: test.labName,
      notAvailableTestId: test.notAvailableTestId,
      prescribed: test.prescribed,
      remarks: test.remarks,
      tempId: test.tempId
    })),
    transcriber: !state.app.transcriberAccountActive
  };

  return axios
    .post(url, body, { headers })
    .then((res) => {
      const responseBody = res.data;

      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function batchDeleteLabTests(authToken, deletions) {
  const headers = {
    authorization: authToken,
  };

  let url = `${config.apiBaseUrl}/prescriptions/labs/batch/remove`;

  const state = store.getState();
  if (state.app.transcriberAccountActive) {
    url = `${config.apiBaseUrl}/digitisations/requests/labs/batch/remove`;
  }

  const body = {
    digitisationId: deletions[0]?.digitisationId, // All deletions should have the same digitisationId
    deletions: deletions.map(deletion => ({
      labId: deletion.labId,
      prescriptionId: deletion.prescriptionId,
      digitisationId: deletion.digitisationId
    })),
    transcriber: !state.app.transcriberAccountActive
  };

  return axios
    .post(url, body, { headers })
    .then((res) => {
      const responseBody = res.data;

      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function previewPrescription(
  authToken,
  prescriptionId,
  diagnosis,
  icdCode,
  secondaryDiagnoses,
  secondaryIcdCodes,
  consultationId,
  doctorType,
  additionalNotes, 
  additionalNotesSecondary,
  weight,
  height
) {
  const headers = {
    authorization: authToken,
  };

  const url = `${config.apiBaseUrl}/prescriptions/preview`;

  return axios
    .post(
      url,
      { prescriptionId, diagnosis, secondaryDiagnoses, secondaryIcdCodes, consultationId, doctorType, icdCode, additionalNotes, additionalNotesSecondary, weight, height },
      { headers }
    )
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function sendPrescription(
  authToken,
  prescriptionId,
  diagnosis,
  icdCode,
  secondaryDiagnoses,
  secondaryIcdCodes,
  consultationId,
  doctorType,
  isTranscriberAccount,
  transcriberDoctorId,
  filesArray, 
  additionalNotes,
  additionalNotesSecondary,
  weight,
  height,
  userId,
  sponsorId
) {
  const headers = {
    authorization: authToken,
  };

  let url = `${config.apiBaseUrl}/prescriptions/send`;
  if (isTranscriberAccount) {
    url = `${config.apiBaseUrl}/prescriptions/send-digitized-rx`;
  }

  const body = {
    prescriptionId, diagnosis, consultationId, doctorType, icdCode, secondaryDiagnoses,
    secondaryIcdCodes, additionalNotes, additionalNotesSecondary, weight, height, userId, sponsorId
  };

  if (transcriberDoctorId) {
    body.transcriberDoctorId = transcriberDoctorId;
  }
  if (filesArray) {
    body.urls = filesArray;
  }

  return axios
    .post(url, body, { headers })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function addAdvicePrescription(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  let url = `${config.apiBaseUrl}/prescriptions/advices/add`;

  const state = store.getState();
  if (state.app.transcriberAccountActive) {
    url = `${config.apiBaseUrl}/digitisations/requests/advices/add`;
  } else {
    body.transcriber = false;
  }

  return axios
    .post(url, body, { headers })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function removeAdvicePrescription(
  authToken,
  adviceId,
  prescriptionId,
  digitisationId
) {
  const headers = {
    authorization: authToken,
  };

  const body = {
    prescriptionId,
    adviceId,
  };

  let url = `${config.apiBaseUrl}/prescriptions/advices/remove`;

  const state = store.getState();
  if (state.app.transcriberAccountActive) {
    body.digitisationId = digitisationId;
    url = `${config.apiBaseUrl}/digitisations/requests/advices/remove`;
  } else {
    body.transcriber = false;
  }

  return axios
    .post(url, body, { headers })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

let labsAbortController = null;
export function getDigitisedLabs(authToken, digitisationId) {
  if (!digitisationId) {
    return Promise.resolve({ labs: [] });
  }
  if (labsAbortController) {
    labsAbortController.abort();
  }
  labsAbortController = new AbortController();
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(
      `${config.apiBaseUrl}/digitisations/requests/labs/get/${digitisationId}`,
      {
        headers,
        // signal: labsAbortController.signal
      }
    )
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      if (!axios.isCancel(err)) {
        showError(err);
        throw err;
      }
    });
}

let medicineAbortController = null;
export function getDigitisedMeds(authToken, digitisationId) {
  if (medicineAbortController) {
    medicineAbortController.abort();
  }
  medicineAbortController = new AbortController();
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(
      `${config.apiBaseUrl}/digitisations/requests/medicines/get/${digitisationId}`,
      {
        headers,
        // signal: medicineAbortController.signal
      }
    )
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      if (!axios.isCancel(err)) {
        showError(err);
        throw err;
      }
    });
}

let adviceAbortController = null;
export function getDigitisedAdvices(authToken, digitisationId) {
  if (adviceAbortController) {
    adviceAbortController.abort();
  }
  adviceAbortController = new AbortController();
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(
      `${config.apiBaseUrl}/digitisations/requests/advices/get/${digitisationId}?v=${config.dashboardVersion}`,
      {
        headers,
        // signal: adviceAbortController.signal
      }
    )
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      if (!axios.isCancel(err)) {
        showError(err);
        throw err;
      }
    });
}

let relativeAbortController = null;
export function getRelativesForDigitisation(authToken, digitisationId) {
  if (relativeAbortController) {
    relativeAbortController.abort();
  }
  relativeAbortController = new AbortController();
  
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(
      `${config.apiBaseUrl}/digitisations/requests/relatives/${digitisationId}`,
      {
        headers,
        params: { v: config.dashboardVersion },
        // signal: relativeAbortController.signal
      }
    )
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      if (!axios.isCancel(err)) {
        showError(err);
        throw err;
      }
    });
}

let pastConsultationAbortController = null;
export function getPastAppointments(authToken, digitisationId) {
  if (pastConsultationAbortController) {
    pastConsultationAbortController.abort();
  }
  pastConsultationAbortController = new AbortController();
  const headers = {
    authorization: authToken,
  };
  return axios
    .get(
      `${config.apiBaseUrl}/digitisations/past-consultations/${digitisationId}`,
      {
        headers,
        // signal: pastConsultationAbortController.signal
      }
    )
    .then((res) => {
      const responseBody = res.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      if (!axios.isCancel(err)) {
        showError(err);
        throw err;
      }
    });
}

export function getCommonDigitisations(authToken, userId, tUserId) {
  const headers = {
    authorization: authToken,
  };
  return axios
    .get(
      `${config.apiBaseUrl}/common-digitisation/fetch-past-digitized-documents?isSecureDocumentUrl=1`,
      {
        headers,
        params: { userId, tUserId, d: 1 }
      }
    )
    .then((res) => {
      const responseBody = res.data;
      if (responseBody.message === 'success' || responseBody.success) {
        return responseBody.result;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function markDigitised(
  authToken,
  diagnosis,
  icdCode,
  digitisationId,
  appointmentDate,
  prescriptionValidityDate,
  doctorName,
  doctorId,
  invalidReason,
  centerName,
  centerAddress,
  centerId,
  relativeId,
  consultationId,
  prescriptionId,
  isCritical,
  secondaryDiagnosis,
  secondaryDiagnosisIcdCode
) {
  const headers = {
    authorization: authToken,
  };

  const body = {
    diagnosis,
    digitisationId,
    appointmentDate,
    prescriptionValidityDate,
    doctorName,
    centerName,
    centerAddress,
    relativeId,
    consultationId,
    prescriptionId,
    isCritical,
    doctorId,
    centerId,
    icdCode,
    secondaryDiagnosis,
    secondaryDiagnosisIcdCode
  };

  if (invalidReason) {
    body.invalidReason = invalidReason;
  }

  return axios
    .post(`${config.apiBaseUrl}/digitisations/requests/mark-digitised?v=${config.dashboardVersion}`, body, {
      headers,
    })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export async function markDigitisedNew(requestBody, authToken, isStarCase, isIlCase) {
  const headers = {
    authorization: authToken,
  };

  if (isStarCase || isIlCase) {
    const relativesData = await getRelativesForDigitisation(authToken, requestBody.digitisationId);
    const selectedUser = isStarCase ? relativesData.relatives.find(item => item.userSelected === 1) : relativesData.selectedUser;
    requestBody.relativeId = selectedUser?.relativeId || -1;
  }

  return axios
    .post(`${config.apiBaseUrl}/digitisations/requests/mark-digitised?v=${config.dashboardVersion}`, requestBody, {
      headers,
    })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getTemplate(authToken, params) {
  const headers = {
    authorization: authToken,
  };
  console.log({ params }, 'getTemplate');
  const url = `${config.apiBaseUrl}/prescriptions/prescription_templates`;
  return axios
    .get(url, { headers, params })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getTemplatesFromId(authToken, templateId) {
  const headers = {
    authorization: authToken,
  };
  const url = `${config.apiBaseUrl}/prescriptions/prescription_templates/id/${templateId}`;
  return axios
    .get(url, { headers })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function addTemplate(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .post(
      `${config.apiBaseUrl}/prescriptions/prescription_templates/create`,
      body,
      {
        headers,
      }
    )
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function updateTemplate(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .put(`${config.apiBaseUrl}/prescriptions/prescription_templates`, body, {
      headers,
    })
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function deleteTemplate(authToken, templateId) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .delete(
      `${config.apiBaseUrl}/prescriptions/prescription_templates/${templateId}`,
      {
        headers,
      }
    )
    .then((res) => {
      const responseBody = res.data;
      
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export async function saveEditedMedicine(authToken, body) {
  const headers = {
    authorization: authToken,
  };
  const url = `${config.pharmaServer}/medicines/save/editedMedicine`;
  const response = await axios.put(url, body, { headers })
  return response.data;

}

export async function removeMedicine(authToken, body) {
  const headers = {
    authorization: authToken,
  };
  const url = `${config.pharmaServer}/medicines/remove`;
  const response = await axios.put(url, body, { headers, params: { v: config.dashboardVersion } })
  return response.data;
}

export async function removeMedicineGroupByMasterItemCode(authToken, body) {
  const headers = {
    authorization: authToken,
  };
  const url = `${config.pharmaServer}/medicines/remove/masterDrugGroup`;
  const response = await axios.put(url,  body, { headers, params: { v: config.dashboardVersion } })
  return response.data;
}

export async function saveMedicineGroup(authToken, body) {

  const headers = {
    authorization: authToken,
  };
  const url = `${config.pharmaServer}/medicines/save/cartItems`;
  const response = await axios.put(url, body, { headers, params: { v: config.dashboardVersion } });
  return response.data;

}

export async function updateCartItemMaxQuantity(cartItemId, newMaxQuantity) {
  const { authToken } = store.getState().user;
  const headers = {
    authorization: authToken,
  };
  const url = `${config.pharmaServer}/digitize-and-book/update-cart-item-max-quantity`;
  return axios
    .post(url, { cartItemId, maxQuantity: newMaxQuantity }, { headers })
    .then((res) => {
      const responseBody = res.data;
      if (responseBody.success) {
        return responseBody.maxQuantity;
      }
      const err = new Error(responseBody.message || responseBody.errorMessage || 'Invalid response');
      err.data = responseBody;
      throw err;
    });
}

export async function updateCartItemOpdCovered(items) {
  const { authToken } = store.getState().user;
  const { digitisationRequestId } = store.getState().digitisation;
  const headers = {
    authorization: authToken,
  };
  const url = `${config.pharmaServer}/digitize-and-book/update-cart-item-opd-covered`;
  // Error is rethrown without showError so the caller can surface the
  // server message (e.g. "Order Is Already Placed For Digitisation Request").
  return axios
    .post(url, { items, digitisationRequestId }, { headers })
    .then((res) => {
      const responseBody = res.data;
      if (responseBody.success) {
        return responseBody;
      }
      const err = new Error(responseBody.message || responseBody.errorMessage || 'Invalid response');
      err.data = responseBody;
      throw err;
    });
}

export async function visitClinicCallBack() {
  const { authToken } = store.getState().user;
  const { digitisationRequestId } = store.getState().digitisation;
  const headers = {
    authorization: authToken,
  };
  const url = `${config.pharmaServer}/digitisation/visit-clinic/callback`;
  // Note: error is rethrown without showError so the caller can detect the
  // "order already pushed" case and surface its own message.
  return axios
    .post(url, { requestDetails: { digitisationRequestId } }, { headers })
    .then((res) => res.data);
}

export async function getMedicineCartItemsByDigitisationId(authToken, digitisationId) {

  if (!digitisationId) {
    return Promise.resolve([]);
  }

  const headers = {
    authorization: authToken,
  };

  
  const url = `${config.pharmaServer}/medicines/cartItems?digitisationId=${digitisationId}&version=1`;
  const response = await axios.get(url, { headers });

  return response.data;

}

export async function getCommonDigitisedItems(authToken, codiId) {

  if (!codiId) {
    return Promise.resolve(false);
  }

  const headers = {
    authorization: authToken,
  };

  
  const url = `${config.apiBaseUrl}/common-digitisation/fetch-past-digitized-carts?d=1&codiIds=${codiId}`;
  const response = await axios.get(url, { headers, params: { v: config.dashboardVersion } });
  return response.data;

}

export async function createCodiMedicine(authToken, medicineBody) {

  const headers = { authorization: authToken };
  const url = `${config.apiBaseUrl}/common-digitisation/insert-medicine?d=1`;
  const response = await axios.post(url, medicineBody, { headers, params: { v: config.dashboardVersion } });
  return response.data;

}


export async function getServicablePartners(authToken) {
  const transcriberAccountActive = store.getState().app.transcriberAccountActive;
  const digitisationId = transcriberAccountActive ? store.getState().digitisation.digitisationRequestId : null;
  const headers = {
    authorization: authToken,
  };

  const url = `${config.pharmaServer}/medicines/visitDrug/serviceable/partners?digitisationId=${digitisationId}`;
  const response = await axios.get(url, { headers, params: { v: config.dashboardVersion } });
  return response.data;

}

export async function getPharmacyServicePartners(icd10Codes = [] ) {
  const { latitude, longitude, pincode, digitisationRequestId } = store.getState().digitisation;
  const { authToken } = store.getState().user;
  const headers = { authorization: authToken };

  try {
    const url = `${config.pharmaServer}/partner/serviceable/list?latitude=${latitude}&longitude=${longitude}&pincode=${pincode}&digitisationId=${digitisationRequestId}${icd10Codes?.length ? `&icd10Codes=${icd10Codes.join(',')}` : ''}`;
    const response = await axios.get(url, { headers, params: { v: config.dashboardVersion } });
    return { partners: response.data.serviceablePartners, city: response.data.city };
  } catch (err) {
    showError(err);
    throw err;
  }

}

export async function updateCriticalIllness(authToken, digitisationId , isCritical) {
  
  const headers = {
    authorization: authToken,
  };
  const body = {
    digitisationId , isCritical
  }

  const url = `${config.apiBaseUrl}/digitisations/update-critical-illness`;
  const response = await axios.put(url,  body, { headers, params: { v: config.dashboardVersion } });
  return response && response.data;

}

export async function getAutoDigitizedData(authToken, digitisationId) {
  console.log({ digitisationId, authToken }, '[digitisationId][getAutoDigitizedData]')
  const headers = {
    authorization: authToken,
  };

  const url = `${config.apiBaseUrl}/common-digitisation/auto-digitisation-data?digitisationId=${digitisationId}`;
  const response = await axios.get(url, { headers, params: { d: 1, v: config.dashboardVersion } });
  console.log(response.data, '[response.data]')
  return response.data;
}

export async function getAIInsights(authToken, digitisationId) {
  console.log({ digitisationId, authToken }, '[digitisationId][getAIInsights]')
  const headers = {
    authorization: authToken,
  };

  try {
    const url = `${config.backendTsApiBaseUrl}/ai-insights/auto-digitisation-meta?digitisationId=${digitisationId}`;
    const response = await axios.get(url, { headers });
    console.log(response.data, '[AI Insights response]')
    return response.data;
  } catch (error) {
    console.error('Error fetching AI insights:', error);
    throw error;
  }
}

export async function getDispositionCategories(authToken, serviceKey = 'online_consultation') {
  const headers = { authorization: authToken };
  const url = `${config.apiBaseUrl}/prescriptions/disposition/categories?serviceKey=${serviceKey}`;
  try {
    const response = await axios.get(url, { headers, params: { v: config.dashboardVersion } });
    if (response.data.message === 'success') {
      return response.data.data;
    }
    throw new Error('Invalid response');
  } catch (err) {
    showError(err);
    throw err;
  }
}

export async function createDispositionEntry(authToken, { type, name, parentId, serviceKey = 'online_consultation' }) {
  const headers = { authorization: authToken };
  const url = `${config.apiBaseUrl}/prescriptions/disposition/categories`;
  const body = { serviceKey, type, name };
  if (parentId) body.parentId = parentId;
  try {
    const response = await axios.post(url, body, { headers, params: { v: config.dashboardVersion } });
    if (response.data.message === 'success') {
      return response.data.data;
    }
    throw new Error('Invalid response');
  } catch (err) {
    showError(err);
    throw err;
  }
}

export async function submitDisposition(authToken, body) {
  const headers = { authorization: authToken };
  const url = `${config.apiBaseUrl}/prescriptions/disposition`;
  try {
    const response = await axios.post(url, body, { headers, params: { v: config.dashboardVersion } });
    if (response.data.message === 'success') {
      return response.data;
    }
    throw new Error('Invalid response');
  } catch (err) {
    showError(err);
    throw err;
  }
}

export async function getUserAddedTests(authToken, digitisationId) {
  if (!digitisationId) {
    return Promise.resolve({ data: [] });
  }

  const headers = {
    authorization: authToken,
  };

  try {
    const url = `${config.apiBaseUrl}/labs-v3/get-test-items?digitisationId=${digitisationId}`;
    const response = await axios.get(url, { headers });
    console.log(response.data, '[User Added Tests response]');

    if (response.data && response.data.message === 'success') {
      return response.data;
    } else {
      const err = new Error('Invalid response');
      err.data = response.data;
      throw err;
    }
  } catch (error) {
    console.error('Error fetching user added tests:', error);
    showError(error);
    throw error;
  }
}

export function getAiVsDoctorDrugCount(authToken, digitisationId) {
  return axios
    .get(`${config.apiBaseUrl}/digitisations/drug-count-comparison`, {
      headers: { authorization: authToken },
      params: { digitisationId },
    })
    .then((res) => res.data);
}
